// --- ENDOSOS ---
export const endosoEstadosGestion = ['Pendiente', 'Gestionado', 'Reclamado'];
export const endosoTiposGestion = [
    'Endoso', 
    'Inclusión',
    'Exclusión', 
    'Aumento de Suma Asegurada', 
    'Reducción de Suma Asegurada', 
    'Cambio de Método de Pago', 
    'Corrección de Datos', 
    'Anulación', 
    'Clausulas de No Repetición',
    'Declaración de Beneficiarios',
    'Refacturación',
    'Ampliación de Cobertura',
    'Reducción de Cobertura'
];


// --- DATOS DE SINIESTROS ---
// Estados de Gestión de Siniestros
export const siniestroEstadosGestion = ['Abierto', 'Cerrado', 'Rechazado', 'Prescribió'];


// Mapeo Condicional: Tipos de Siniestro según Riesgo (Replicado del HTML original)
export const siniestroMappings = {
    'AUTOMOTORES': ['Cristales', 'Robo de Ruedas', 'Granizo', 'Accidente Total', 'Accidente Parcial', 'Robo Total', 'Robo Parcial', 'Daños Multiples', 'Responsabilidad Civil', 'Inundación', 'Cerradura', 'Incendio Total', 'Incendio Parcial'],
    'MOTOVEHÍCULOS': ['Cristales', 'Robo de Ruedas', 'Granizo', 'Accidente Total', 'Accidente Parcial', 'Robo Total', 'Robo Parcial', 'Daños Multiples', 'Responsabilidad Civil'],
    'CAMIÓN': ['Cristales', 'Robo de Ruedas', 'Granizo', 'Accidente Total', 'Accidente Parcial', 'Robo Total', 'Robo Parcial', 'Daños Multiples', 'Responsabilidad Civil'],
    'INTEGRAL DE COMERCIO': ['Cristales', 'Daños por Agua', 'Impacto de Vehículo', 'Incendio', 'Rayo - Accidentes', 'RC Daños Materiales', 'RC Lesiones', 'Robo', 'VTCH-Granizo', 'Pérdida de Frío', 'Equipos Electrónicos'],
    'INTEGRAL DE CONSORCIO': ['Cristales', 'Daños por Agua', 'Impacto de Vehículo', 'Incendio', 'Rayo - Accidentes', 'RC Daños Materiales', 'RC Lesiones', 'Robo', 'VTCH-Granizo', 'Pérdida de Frío', 'Equipos Electrónicos'],
    'COMBINADO FAMILIAR': ['Cristales', 'Daños por Agua', 'Impacto de Vehículo', 'Incendio', 'Rayo - Accidentes', 'RC Daños Materiales', 'RC Lesiones', 'Robo', 'VTCH-Granizo','Pérdida de Frío', 'Equipos Electrónicos'],
    'INCENDIO': ['Cristales', 'Daños por Agua', 'Impacto de Vehículo', 'Incendio', 'Rayo - Accidentes', 'RC Daños Materiales', 'RC Lesiones', 'Robo', 'VTCH-Granizo'],
    'ACCIDENTES PERSONALES': ['Muerte', 'Invalidez', 'Asistencia Medica/Farmaceútica'],
    'TRANSPORTE': ['Vuelco', 'Robo', 'Hurto', 'Choque', 'Rotura', 'Carga y Descarga', 'Falta de Entrega', 'Desaparición', 'Incendio', 'Mojadura', 'Desbarrancamiento', 'Otro'],
    'RESPONSABILIDAD CIVIL': ['Otro'],
    'ROBO-RIESGOS SIMILARES': ['Robo', 'Accidentes', 'Responsabilidad Civil', 'Incendio'],
    'ROBO': ['Otros'],
    'RIESGOS VARIOS': ['Otros'],
    'SALUD': ['Otros'],
    'AERONAVEGACIÓN': ['Otros'],
    'CASCO': ['Naufragio', 'Varamiento', 'Incendio, Rayo y/o Explosión', 'Choque', 'Temporal', 'Robo', 'Salvamento', 'Responsabilidad civil'],
    'ROBO': ['Otros'],
    'MALA PRAXIS INSTITUCIONAL': ['Otros'],
    'MALA PRAXIS MÉDICA': ['Otros'],
    'SEGURO TÉCNICO': ['Accidente', 'Incendio', 'Robo', 'Fallas eléctricas', 'Responsabilidad Civil', 'Rotura de Maquinaria', 'Imprevistos y Falla Humana','Daños por la Naturaleza','Errores de Montaje','Gastos'],
    'MALA PRAXIS MÉDICA': ['Otros'],
    'SEPELIO': ['Otros'],
    'TODO RIESGO OPERATIVO': ['Otros'],
    'VIDA COLECTIVO': ['Otros'],
    'VIDA INDIVIDUAL': ['Otros'],
    'VIDA OBLIGATORIO': ['Otros'],
    'CAUCIÓN': ['Otros'],
    'CAUCION': ['Otros']
};


// Opciones de Registro de Gestión (se usan en el historial de gestiones dentro del modal)
export const gestionTipos = ['Solicitud de Documentación', 'Inspección', 'Respuesta CLEAS', 'Proceso de Reparación', 'Denunciado el Reclamo de Terceros', 'Autodenunciado por WEB/APP', 'Acuerdo Indemnizatorio',  'Pendiente Liquidación','Observaciones Generales'];


// --- DATOS DE COBRANZA (NUEVO) ---
export const cobranzaEstados = [
    'Sin Asignar',
    'Pendiente', 
    'Informada', 
    'Reclamada', 
    'CBU Readherido',
    'TC Readherido',
    'Cobrada',
    'Debitada',
    'Acreditada',
    'Incobrable',
    'Anulada'
];

export const cobranzaEstadosDeuda = [
    'Intento de Cobro', 
    'Rechazo',
    'Próxima a Vencer',
    'Vencida'
];


export const formaPago = [
    'Tarjeta de Crédito', 
    'CBU', 
    'Cupones'
];

export const cobranzaEstadosContratoArt = [
    'Normalizado',
    'En Proceso de Intimación', 
    'En Proceso de Anulación',
    'Suspendido',
    'Anulado'
];

export const cobranzaEstadosDeudaArt  = [
    'Al día',
    'Con Deuda',
    'Incobrable'

];

export const cobranzaEstadosGestionArt = [
    'Sin Asignar',
    'Pendiente', 
    'Informada', 
    'Reclamada',
    'Compromiso de Pago',
    'Plan de Pago',
    'Legales / Judicial',
    'Cobrada'
]; 

export const tiposMovimientoArt = [
    'Saldo Inicial',
    'Aumento de Deuda', 
    'Intereses', 
    'Disminución de Deuda',
    'Nota de Crédito',

];


// --- DATOS DE REFACTURACIONES ---
export const refacturacionEstados = ['Deuda Reclamada', 'Refacturación Enviada', 'Abonado - Falta Recibo', 'Moroso', 'Revisión', 'Abonado', 'Anulada', 'Incobrable', 'Debitada'];


// --- DATOS EMISION ---
export const formasPagoList = [
    'Tarjeta de Crédito',
    'CBU',
    'Transferencia',
    'Cupones',
    'Débito Afip',
    'Adelanto y Financiado',
    'Adelanto y CBU',
    'Adelanto y Tarjeta'
];

export const tiposFacturacionList = [
    'Vigencia Cerrada',
    'Mensual',
    'Bimestral',
    'Trimestral',
    'Cuatrimestral',
    'Semestral',
    'Anual',
    'Bianual',
    'Trianual'
];

export const CANALES_DISPONIBLES = [
    'Agente',
    'Pas',
    'Operatoria',
    'Directo'
];

export const estadoEmision = [
    'NO INICIADA',
    'VIGENTE',
    'PENDIENTE DE EMISIÓN',
    'PENDIENTE DE INSPECCIÓN',
    'PROPUESTA INGRESADA',
    'VENCIDA',
    'ANULADA',
];

export const motivo = [
    'Póliza Nueva',
    'Póliza Histórica',
    'Cambio de PAS',
    'Cuenta Bancaria',
    'Emisión por Reemplazo',
    'Renovación',
];

export const tipoOperacionArt = [
    'Contrato Nuevo',
    'Contrato Histórico',
];

export const subOperacionArt = [
    'Afiliación',
    'Reafiliación',
    'Traspaso',
];

export const submotivo = [
    'Emisión Nueva',
    'Emisión Fuera de Término',
    'Emisión por Reemplazo',
    'Cambio de PAS',
    'Continuidad de Cobertura',
    'Cambio de Compañia',
];

export const formaDespacho = [
    'Whatsapp',
    'Mail',
    'Agente',
    'Marcos',
    'Oficina',
    'No Despachar'
];

export const tiposConversionList = [
    'Cliente',
    'Croselling',
    'Referido',
    'Productor',
    'Whatsapp',
    'Telefono',
    'Prospecto Web',
    'Redes Sociales',
    'Oficina',
    'Otro tipo',
    'Desconoce',
];

// --- DATOS RENOVACION ---
export const estadoGestionRenovacion = [
    'RECOTIZANDO',
    'CONSULTE SI RENUEVA',
    'REVISION',
    'PENDIENTE DE ENVIO',
    'PLAN DE PAGO',
    'DEUDA INFORMADA',
    'NO RENUEVA',
    'RENOVADA',
];

export const tipoRenovacion = [
    'No Renovable',
    'Temporal',
    'Renovable'
];


// --- GESTIÓN DE CONTACTOS (NUEVO) ---
export const cargos = [
    'Presidente',
    'Gerente',
    'Apoderado',
    'Socio',
    'Dueño',
    'Recursos Humanos',
    'Contador',
    'Proveedores',
    'Administración'
];

// --- GESTIÓN DE COTIZACIONES ART (NUEVO) ---
export const EstadoCotizacionArt = [
    'Pendiente',
    'Solicitud de Cotización',
    'Cotizando',
    'Esperando Respuesta',
    'Seguimiento',
    'Sin Costo',
    'Sin Respuesta',
    'Cancelada por el Cliente',
    'Gestión Finalizada',
    'Cerrada Ganada',
    'Cerrada Perdida',
];

export const TipoGestionArt = [
    'Venta',
    'Recotización',
    'Aumento de Tarifa'
];

export const EstadoEndosoArt = [
    'Pendiente',
    'Informado',
    'Cotizado',
    'Gestionado'
];

export const etapasPostVentaList = [
    'Primer Contacto',
    'Recordatorio de Cobro',
    'Chequeo de Cobro',
    'Número Utiles y/o Asistencia',
    'Asesoramiento de Cobertura',
    'Croselling',
    'Revisión de Riesgos',
    'Próxima Renovación'
];

export const motivoNoRenueva = [
    'Costo',
    'Deuda en Compañia',
    'Desestimiento',
    'Disconformidad',
    'Siniestro',
    'Sin Respuesta',
    'Venta',
    'Otros',
];





